module.exports = __webpack_public_path__ + "img/38376-006.18aa39fb.jpg";